import { SwiperSlide, Swiper } from "swiper/react";
import { useRabbitFestivalContext } from "../../../../hooks/festival-context";
import { FestivalRoundButton } from "../../../../style";
import {
  FestivalMainCompetitionButton,
  FestivalMainCompetitionHeader,
  FestivalMainCompetitionHeaderRound,
  FestivalMainCompetitionSwiperItem,
  FestivalMainCompetitionSwiperText,
  FestivalMainCompetitionSwiperWrapper,
  FestivalMainCompetitionWrapper,
} from "./style";
import { useState } from "react";
import RabbitFestivalMainCompetitionSkeleton from "./skeleton";
import { RabbitFestivalPage } from "../../../../hooks/use-festival-tab";
import { RunnerCompetitionDto } from "../../../../../../../api/runner-competition";

const RabbitFestivalMainCompetition = () => {
  const { competitions, mainLoading, setFestivalPage, handleCompetitionPage } =
    useRabbitFestivalContext();
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleClick = () => {
    const data = competitions[currentIndex];
    handleCompetitionPage(data.id);
  };

  const isEndCompetition = (item: RunnerCompetitionDto) => {
    if (!item.endDate) return false;

    const endDate = new Date(item.endDate).getTime();
    const now = Date.now();

    return endDate < now;
  };

  if (mainLoading) {
    return <RabbitFestivalMainCompetitionSkeleton />;
  }
  return (
    <FestivalMainCompetitionWrapper>
      <FestivalMainCompetitionHeader>
        <div className="title">대회 정보</div>
        <FestivalRoundButton
          onClick={() => setFestivalPage(RabbitFestivalPage.COMPETITIONS)}
        >
          더보기 <img src="/image-web/rabbit/right_arrow.svg" alt="arrow" />
        </FestivalRoundButton>
      </FestivalMainCompetitionHeader>
      <FestivalMainCompetitionSwiperWrapper>
        <FestivalMainCompetitionHeaderRound isTop={true} />
        <Swiper
          key={competitions.length}
          className="banner-swiper"
          slidesPerView={1.2}
          spaceBetween={12}
          centeredSlides={true}
          onRealIndexChange={(swiper: any) =>
            setCurrentIndex(swiper.realIndex || 0)
          }
        >
          {competitions.map((item, i) => (
            <SwiperSlide key={i}>
              <FestivalMainCompetitionSwiperItem>
                <img src={item.bannerImage} alt="competition" />
                {isEndCompetition(item) ? (
                  <div className="mask" />
                ) : (
                  <div className="back" />
                )}
                <FestivalMainCompetitionSwiperText>
                  <div className="title">{item.title}</div>
                  <div className="subTitle">{item.subTitle}</div>
                </FestivalMainCompetitionSwiperText>
              </FestivalMainCompetitionSwiperItem>
            </SwiperSlide>
          ))}
        </Swiper>
        <FestivalMainCompetitionButton
          isEnd={isEndCompetition(competitions[currentIndex])}
          onClick={handleClick}
        >
          <div className="button">자세히 보기</div>
        </FestivalMainCompetitionButton>
        <FestivalMainCompetitionHeaderRound isTop={false} />
      </FestivalMainCompetitionSwiperWrapper>
    </FestivalMainCompetitionWrapper>
  );
};

export default RabbitFestivalMainCompetition;
